<template>
  <SingleLensDetails v-if="lens" :select="lens" :isSharedView="true" />
  <div v-else class="loader-div">
    <div class="loader"></div>
  </div>
</template>

<script setup>
import SingleLensDetails from '@/components/SingleLensDetails.vue'
import { getSharedLensDetail } from '@/api/share-lens'
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useToastStore } from '@/stores/Toast'

const route = useRoute()
const router = useRouter()
const toastStore = useToastStore()

const lens = ref(null)
const shareHash = ref(route.query.hash)

if (!shareHash.value) {
  toastStore.showToast('error', 'Invalid share link!')
  router.push('/')
}

const fetchLensDetails = async () => {
  const response = await getSharedLensDetail(shareHash.value)

  if (!response.data) {
    toastStore.showToast('error', response?.message || 'Failed to get lens details!')
    router.push('/')
    return
  }

  // complete data with category info
  const lensesCompleteData = response.data?.lensData
  // lenses array has the actual lens data
  const singleLensData = lensesCompleteData?.lenses[0]
  // adding category name to the lens data
  singleLensData.categoryName = lensesCompleteData.name

  lens.value = singleLensData

  // check if sceneHash is present in the URL
  if (response.data?.sceneType) {
    switch (response.data?.sceneType) {
      case 'sceneImage1':
        if (lens.value.sceneImage1) lens.value.sceneImageUrl = lens.value.sceneImage1
        break
      case 'sceneImage2':
        if (lens.value.sceneImage2) lens.value.sceneImageUrl = lens.value.sceneImage2
        break
      case 'sceneImage3':
        if (lens.value.sceneImage3) lens.value.sceneImageUrl = lens.value.sceneImage3
        break
    }
  }
}

onMounted(async () => {
  await fetchLensDetails()
})
</script>
